import { AfterViewInit, Component, OnInit, inject, input, model, output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';

import { FormlyService } from '../../services/component-services/formly.service';
import { FormService } from '../../services/component-services/form.service';

@Component({
  selector: 'app-base-form',
  templateUrl: './base-form.component.html',
  styleUrl: './base-form.component.scss',
  imports: [FormlyModule],
})
export class BaseFormComponent implements OnInit, AfterViewInit {
  private readonly formService = inject(FormService);
  private readonly formlyService = inject(FormlyService);

  public readonly fields = input<FormlyFieldConfig[]>();
  public readonly model = model<any>({});
  public readonly mobile = input(false);
  public readonly saveText = input<string>();
  public readonly focusFieldIndex = input<number>();
  public readonly save = output<any>();

  protected form: UntypedFormGroup = new UntypedFormGroup({});
  protected options: FormlyFormOptions = {};

  ngOnInit(): void {
    if (this.saveText()) {
      this.fields().push(
        this.formlyService.button(
          this.saveText(),
          () => this.save.emit(this.model()),
          { mobile: this.mobile() },
          undefined,
          {
            'props.disabled': () => this.form.invalid,
          },
        ),
      );
    }
  }

  ngAfterViewInit(): void {
    if (this.focusFieldIndex() >= 0) {
      this.focusField(this.focusFieldIndex());
    }
  }

  updateModel(model: any, markUpdated = true, markUnchanged = false) {
    this.model.set({ ...this.model(), ...model });
    if (markUpdated) {
      this.form.markAsDirty();
      this.form.markAllAsTouched();
    }
    if (markUnchanged) {
      this.form.markAsPristine();
      this.form.markAsUntouched();
    }
  }

  focusField(focusFieldIndex: number) {
    this.fields()[focusFieldIndex].focus = true;
  }

  validate(): boolean {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.formService.scrollToFirstInvalidField();
      return false;
    }

    this.form.markAsPristine();
    this.form.markAsUntouched();
    return true;
  }
}
